export default "__VITE_ASSET__BFrVkgo1__"